export const ADD_KE_FAMILY_MEMBER_MODAL_NAME =
  'ADD_KE_FAMILY_MEMBER_MODAL_NAME';
